/* RovaHair main product — variant switching, gallery, add to cart. */
(function () {
  function money(cents) {
    var fmt = window.RV_MONEY_FORMAT || '${{amount}}';
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    var amount = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function whenGlide(cb, tries) {
    tries = tries || 0;
    if (window.Glide) return cb(window.Glide);
    if (tries > 100) return;
    setTimeout(function () { whenGlide(cb, tries + 1); }, 60);
  }

  if (customElements.get('rv-product')) return;

  class RvProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-rvp-json]').textContent); } catch (e) { this.data = { variants: [] }; }
      this.stage = this.querySelector('[data-rvp-stage]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-rvp-media]'));
      this.counter = this.querySelector('[data-rvp-count]');
      this.mq = window.matchMedia('(max-width: 749px)');
      this.bindThumbs();
      this.bindSwipe();
      this.bindOptions();
      this.bindForm();
      this.mountSliders();
    }

    /* ---------- gallery ---------- */
    activateMedia(id, scroll) {
      id = String(id);
      var idx = -1;
      this.slides.forEach(function (s, i) {
        var on = s.getAttribute('data-rvp-media') === id;
        s.classList.toggle('is-active', on);
        if (on) idx = i;
      });
      if (idx < 0) return;
      this.querySelectorAll('[data-rvp-thumb]').forEach(function (t) {
        var on = t.getAttribute('data-rvp-thumb') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (this.thumbGlide && this.thumbGlide.settings.type === 'carousel') {
        try { this.thumbGlide.go('=' + idx); } catch (e) {}
      }
      this.setCount(idx);
      if (this.mq.matches && this.stage && scroll !== false) {
        this.stage.scrollTo({ left: idx * this.stage.clientWidth, behavior: 'smooth' });
      }
    }

    setCount(idx) {
      if (this.counter) this.counter.textContent = (idx + 1) + '/' + this.slides.length;
    }

    bindThumbs() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target.closest('[data-rvp-thumb]');
        if (!t || !self.contains(t)) return;
        self.activateMedia(t.getAttribute('data-rvp-thumb'));
      });
    }

    bindSwipe() {
      var self = this, timer;
      if (!this.stage || this.slides.length < 2) return;
      this.stage.addEventListener('scroll', function () {
        if (!self.mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var w = self.stage.clientWidth || 1;
          var idx = Math.max(0, Math.min(self.slides.length - 1, Math.round(self.stage.scrollLeft / w)));
          self.setCount(idx);
          var id = self.slides[idx].getAttribute('data-rvp-media');
          self.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
          self.querySelectorAll('[data-rvp-thumb]').forEach(function (t) {
            var on = t.getAttribute('data-rvp-thumb') === id;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }, 80);
      }, { passive: true });
    }

    /* ---------- variants ---------- */
    bindOptions() {
      var self = this;
      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-rvp-opt]')) self.onOptionChange();
      });
    }

    currentOptions() {
      var opts = [];
      this.querySelectorAll('.rvp-fieldset').forEach(function (fs) {
        var sel = fs.querySelector('select[data-rvp-opt]');
        var r = fs.querySelector('input[data-rvp-opt]:checked');
        opts.push(sel ? sel.value : (r ? r.value : null));
      });
      return opts;
    }

    onOptionChange() {
      var opts = this.currentOptions();
      var v = (this.data.variants || []).find(function (x) {
        return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
      this.updateVariant(v);
    }

    updateVariant(v) {
      var add = this.querySelector('[data-rvp-add]');
      var addText = this.querySelector('[data-rvp-add-text]');
      var idInput = this.querySelector('[data-rvp-id]');
      if (!v) {
        if (add) { add.disabled = true; if (addText) addText.textContent = add.dataset.unavailableText || 'Unavailable'; }
        return;
      }
      this.variant = v;
      if (idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var price = this.querySelector('[data-rvp-price]');
      var cmp = this.querySelector('[data-rvp-compare]');
      var sale = this.querySelector('[data-rvp-sale]');
      if (price) price.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.textContent = onSale ? money(v.compare_at_price) : ''; cmp.hidden = !onSale; }
      if (sale) sale.hidden = !onSale;
      if (add) {
        add.disabled = !v.available;
        var tpl = v.available ? (add.dataset.addText || 'Add to cart') : (add.dataset.soldOutText || 'Sold out');
        if (addText) addText.innerHTML = tpl.replace('[PRICE]', money(v.price));
      }
      if (v.featured_media_id) this.activateMedia(v.featured_media_id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      this.dispatchEvent(new CustomEvent('rv:variant-change', { bubbles: true, detail: { variant: v } }));
    }

    /* ---------- add to cart ---------- */
    bindForm() {
      var form = this.querySelector('form.rvp-form');
      if (!form) return;
      var add = form.querySelector('[data-rvp-add]');
      var action = add ? add.dataset.cartAction : 'cart_drawer';
      if (action === 'go_to_cart') return; // native submit → /cart
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!add || add.disabled || add.getAttribute('aria-busy') === 'true') return;
        add.setAttribute('aria-busy', 'true');
        add.style.opacity = '.7';
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var fd = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        fetch(window.RV_CART_ADD_URL || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { // error from Shopify (e.g. sold out)
              alertInline(form, data.description || data.message);
              return;
            }
            if (action === 'go_to_checkout') { window.location.href = '/checkout'; return; }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rv-main-product', productVariantId: fd.get('id'), cartData: data }); } catch (e) {}
            }
            document.dispatchEvent(new CustomEvent('rv:cart-added', { detail: data }));
            if (action === 'ajax') return;
            if (cart && typeof cart.renderContents === 'function') {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              cart.renderContents(data);
            } else {
              window.location.href = window.RV_CART_URL || '/cart';
            }
          })
          .catch(function () { window.location.href = window.RV_CART_URL || '/cart'; })
          .finally(function () { add.removeAttribute('aria-busy'); add.style.opacity = ''; });
      });

      function alertInline(f, msg) {
        var el = f.querySelector('.rvp-err');
        if (!el) {
          el = document.createElement('p');
          el.className = 'rvp-err';
          el.setAttribute('role', 'alert');
          el.style.cssText = 'margin:.4rem 0 0;color:#b42318;font-size:1.3rem';
          f.appendChild(el);
        }
        el.textContent = msg || 'Could not add to cart.';
      }
    }

    /* ---------- sliders ---------- */
    mountSliders() {
      var self = this;
      var thumbs = this.querySelector('[data-rvp-glide="thumbs"]');
      var reviews = this.querySelectorAll('[data-rvp-glide="reviews"]');
      if (!thumbs && !reviews.length) return;
      whenGlide(function (Glide) {
        if (thumbs) {
          var size = parseInt(thumbs.dataset.size, 10) || 1;
          var per = parseInt(thumbs.dataset.per, 10) || 5;
          self.thumbGlide = new Glide(thumbs, {
            type: size > per ? 'carousel' : 'slider',
            perView: per,
            gap: parseInt(thumbs.dataset.gap, 10) || 10,
            bound: true,
            rewind: false,
            animationDuration: 350,
            breakpoints: { 750: { perView: Math.min(per, size) } }
          }).mount();
        }
        reviews.forEach(function (el) {
          var n = parseInt(el.dataset.size, 10) || 1;
          new Glide(el, {
            type: n > 1 ? 'carousel' : 'slider',
            perView: 1,
            gap: 0,
            autoplay: n > 1 ? 5000 : false,
            hoverpause: true,
            animationDuration: 400
          }).mount();
        });
      });
    }
  }

  customElements.define('rv-product', RvProduct);
})();
